var is_table, tableH, tableTop, trTop, tableCloseH, sixpad = sixpad || {}, $window = $(window), isLoad = !1, isAnchorScroll = !1, pageID = "";
$("body").hasClass("faq") && (pageID = "FAQ"),
$("body").hasClass("subscription") && (is_table = !1);
var throttle = function() {
    var t, i, s = Date.now();
    return function(e) {
        (t = s + 256 - Date.now()) < 0 ? (e(),
        s = Date.now()) : (clearTimeout(i),
        i = setTimeout(function() {
            e()
        }, 256 - t + 15))
    }
}();
$(function() {
    var t, i, s, a, r, o, n, l, c, e, u, d;
    if (getdoubleDigestNumer = function(e) {
        return ("0" + e).slice(-2)
    }
    ,
    $("body").hasClass("application") && (p = getdoubleDigestNumer($("#carousel-app-feature").find("li").length),
    $("#carousel-app-feature").find(".c-carousel-count__total").html(p),
    t = new Swiper("#carousel-app-feature .swiper-container",{
        slidesPerView: 1,
        spaceBetween: 0,
        slidesOffsetAfter: 0,
        effect: "fade",
        loop: !0,
        speed: 500,
        navigation: {
            nextEl: "#carousel-app-feature .c-carousel-navi-next",
            prevEl: "#carousel-app-feature .c-carousel-navi-prev"
        }
    }),
    $current_target1 = $("#carousel-app-feature").find(".c-carousel-count__current"),
    t.on("slideChange", function() {
        var e = getdoubleDigestNumer(t.realIndex + 1);
        $current_target1.html(e)
    })),
    $("body").hasClass("thebike") && ($uservoice = $("#uservoice"),
    v = getdoubleDigestNumer($uservoice.find(".uservoice-list-item").length),
    $uservoice.find(".c-carousel-count__total").html(v),
    i = new Swiper("#uservoice .swiper-container",{
        setWrapperSize: !0,
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesOffsetAfter: 0,
        centeredSlides: !0,
        loop: !0,
        speed: 800,
        autoplay: {
            delay: 3500
        },
        breakpoints: {
            768: {
                slidesPerView: "auto",
                spaceBetween: 0,
                slidesOffsetAfter: 0
            }
        },
        navigation: {
            nextEl: "#uservoice .c-carousel-navi-next",
            prevEl: "#uservoice .c-carousel-navi-prev"
        }
    }),
    s = $uservoice.find(".c-carousel-count__current"),
    i.on("slideChange", function() {
        var e = getdoubleDigestNumer(i.realIndex + 1);
        s.html(e)
    }),
    $(".support-faq-list__item").each(function() {
        var t = $(this);
        $(this).find(".support-faq-list__item__q").on("click", function() {
            var e;
            return t.hasClass("active") ? (t.removeClass("active"),
            t.find(".support-faq-list__item__a").css("max-height", "")) : (t.addClass("active"),
            e = t.find(".support-faq-list__item__a-inner").outerHeight(),
            t.find(".support-faq-list__item__a").css("max-height", e + 50)),
            !1
        })
    })),
    $("body").hasClass("powersuit") && ($uservoice = $("#uservoice"),
    v = getdoubleDigestNumer($uservoice.find(".uservoice-list-item").length),
    $uservoice.find(".c-carousel-count__total").html(v),
    i = new Swiper("#uservoice .swiper-container",{
        setWrapperSize: !0,
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesOffsetAfter: 0,
        centeredSlides: !0,
        loop: !0,
        speed: 800,
        autoplay: {
            delay: 3500
        },
        breakpoints: {
            768: {
                slidesPerView: "auto",
                spaceBetween: 0,
                slidesOffsetAfter: 0
            }
        },
        navigation: {
            nextEl: "#uservoice .c-carousel-navi-next",
            prevEl: "#uservoice .c-carousel-navi-prev"
        }
    }),
    s = $uservoice.find(".c-carousel-count__current"),
    i.on("slideChange", function() {
        var e = getdoubleDigestNumer(i.realIndex + 1);
        s.html(e)
    }),
    $(".support-faq-list__item").each(function() {
        var t = $(this);
        $(this).find(".support-faq-list__item__q").on("click", function() {
            var e;
            return t.hasClass("active") ? (t.removeClass("active"),
            t.find(".support-faq-list__item__a").css("max-height", "")) : (t.addClass("active"),
            e = t.find(".support-faq-list__item__a-inner").outerHeight(),
            t.find(".support-faq-list__item__a").css("max-height", e + 50)),
            !1
        })
    })),
    $("body").hasClass("campaign") && ($uservoice = $("#uservoice"),
    v = getdoubleDigestNumer($uservoice.find(".uservoice-list-item").length),
    $uservoice.find(".c-carousel-count__total").html(v),
    i = new Swiper("#uservoice .swiper-container",{
        setWrapperSize: !0,
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesOffsetAfter: 0,
        centeredSlides: !0,
        loop: !0,
        speed: 800,
        autoplay: {
            delay: 3500
        },
        breakpoints: {
            768: {
                slidesPerView: "auto",
                spaceBetween: 0,
                slidesOffsetAfter: 0
            }
        },
        navigation: {
            nextEl: "#uservoice .c-carousel-navi-next",
            prevEl: "#uservoice .c-carousel-navi-prev"
        }
    }),
    s = $uservoice.find(".c-carousel-count__current"),
    i.on("slideChange", function() {
        var e = getdoubleDigestNumer(i.realIndex + 1);
        s.html(e)
    }),
    $(".support-faq-list__item").each(function() {
        var t = $(this);
        $(this).find(".support-faq-list__item__q").on("click", function() {
            var e;
            return t.hasClass("active") ? (t.removeClass("active"),
            t.find(".support-faq-list__item__a").css("max-height", "")) : (t.addClass("active"),
            e = t.find(".support-faq-list__item__a-inner").outerHeight(),
            t.find(".support-faq-list__item__a").css("max-height", e + 50)),
            !1
        })
    })),
    $("body").hasClass("lesson")) {
        var p = getdoubleDigestNumer($("#carousel-wave-feature").find("li").length);
        $("#carousel-wave-feature").find(".c-carousel-count__total").html(p);
        var f = new Swiper("#carousel-wave-feature .swiper-container",{
            setWrapperSize: !0,
            slidesPerView: "auto",
            spaceBetween: 0,
            slidesOffsetAfter: 0,
            loop: !0,
            speed: 500,
            breakpoints: {
                768: {
                    slidesPerView: "auto",
                    spaceBetween: 0,
                    slidesOffsetAfter: 0
                }
            },
            navigation: {
                nextEl: "#carousel-wave-feature .c-carousel-navi-next",
                prevEl: "#carousel-wave-feature .c-carousel-navi-prev"
            }
        });
        $current_target1 = $("#carousel-wave-feature").find(".c-carousel-count__current"),
        f.on("slideChange", function() {
            var e = getdoubleDigestNumer(f.realIndex + 1);
            $current_target1.html(e)
        }),
        $feature_app = $("#feature");
        var h = $feature_app.find(".feature-app-slide-item").length;
        $feature_app.find(".c-carousel-count__total").html(getdoubleDigestNumer(h));
        for (var m = new Swiper("#feature .swiper-container",{
            setWrapperSize: !0,
            slidesPerView: "auto",
            spaceBetween: 0,
            slidesOffsetAfter: 0,
            centeredSlides: !0,
            loop: !0,
            speed: 500,
            autoplay: {
                disableOnInteraction: !1,
                delay: 3500
            },
            navigation: {
                nextEl: "#feature .c-carousel-navi-next",
                prevEl: "#feature .c-carousel-navi-prev"
            }
        }), g = 0; g < h; g++)
            $("#feature .current-numbers").append('<div class="number">' + getdoubleDigestNumer(g + 1) + "</div>");
        $app_current_numbers = $("#feature .current-numbers"),
        $app_c_slide_captions = $("#feature .c-slide-captions"),
        m.on("slideChange", function() {
            console.log(this.realIndex);
            var e = $app_current_numbers.find(".number").eq(this.realIndex - 1).position().top;
            $app_current_numbers.css("transform", "translate(0px," + -e + "px");
            e = $c_slide_captions.find(".caption").eq(this.realIndex - 1).position().top;
            $app_c_slide_captions.css("transform", "translate(0px," + -e + "px")
        });
        var v = getdoubleDigestNumer($("#carousel-training_menu").find("li").length);
        $("#carousel-training_menu").find(".c-carousel-count__total").html(v);
        var b = new Swiper("#carousel-training_menu .swiper-container",{
            setWrapperSize: !0,
            slidesPerView: "auto",
            spaceBetween: 0,
            slidesOffsetAfter: 0,
            loop: !0,
            speed: 500,
            breakpoints: {
                768: {
                    slidesPerView: "auto",
                    spaceBetween: 0,
                    slidesOffsetAfter: 0
                }
            },
            navigation: {
                nextEl: "#carousel-training_menu .c-carousel-navi-next",
                prevEl: "#carousel-training_menu .c-carousel-navi-prev"
            }
        });
        s = $("#carousel-training_menu").find(".c-carousel-count__current"),
        b.on("slideChange", function() {
            var e = getdoubleDigestNumer(b.realIndex + 1);
            s.html(e)
        })
    }
    $("body").hasClass("studio_lesson") && (p = getdoubleDigestNumer($("#carousel-facility").find("li").length),
    $("#carousel-facility").find(".c-carousel-count__total").html(p),
    a = new Swiper("#carousel-facility .swiper-container",{
        setWrapperSize: !0,
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesOffsetAfter: 0,
        loop: !0,
        speed: 500,
        breakpoints: {
            768: {
                slidesPerView: "auto",
                spaceBetween: 0,
                slidesOffsetAfter: 0
            }
        },
        navigation: {
            nextEl: "#carousel-facility .c-carousel-navi-next",
            prevEl: "#carousel-facility .c-carousel-navi-prev"
        }
    }),
    $current_target1 = $("#carousel-facility").find(".c-carousel-count__current"),
    a.on("slideChange", function() {
        var e = getdoubleDigestNumer(a.realIndex + 1);
        $current_target1.html(e)
    })),
    $("body").hasClass("subscription") && ($powersuit_set = $("#carousel-cart-powersuit_set"),
    p = $powersuit_set.find("li").length,
    $powersuit_set.find(".c-carousel-count__total").html(getdoubleDigestNumer(p)),
    r = new Swiper("#carousel-cart-powersuit_set .swiper-container",{
        setWrapperSize: !0,
        slidesPerView: 1,
        spaceBetween: 0,
        slidesOffsetAfter: 0,
        effect: "fade",
        loop: !0,
        speed: 400,
        navigation: {
            nextEl: "#carousel-cart-powersuit_set .c-carousel-navi-next",
            prevEl: "#carousel-cart-powersuit_set .c-carousel-navi-prev"
        }
    }),
    $current_target1 = $powersuit_set.find(".c-carousel-count__current"),
    r.on("slideChange", function() {
        var e = getdoubleDigestNumer(r.realIndex + 1);
        $current_target1.html(e)
    }),
    1 == p && $powersuit_set.find("#swiper-navigation").addClass("is-hide"),
    $powersuit_top = $("#carousel-cart-powersuit_top"),
    v = $powersuit_top.find("li").length,
    $powersuit_top.find(".c-carousel-count__total").html(getdoubleDigestNumer(v)),
    o = new Swiper("#carousel-cart-powersuit_top .swiper-container",{
        setWrapperSize: !0,
        slidesPerView: 1,
        spaceBetween: 0,
        slidesOffsetAfter: 0,
        effect: "fade",
        loop: !0,
        speed: 400,
        navigation: {
            nextEl: "#carousel-cart-powersuit_top .c-carousel-navi-next",
            prevEl: "#carousel-cart-powersuit_top .c-carousel-navi-prev"
        }
    }),
    s = $powersuit_top.find(".c-carousel-count__current"),
    o.on("slideChange", function() {
        var e = getdoubleDigestNumer(o.realIndex + 1);
        s.html(e)
    }),
    1 == v && $powersuit_top.find("#swiper-navigation").addClass("is-hide"),
    $powersuit_bottom = $("#carousel-cart-powersuit_bottom"),
    e = $powersuit_bottom.find("li").length,
    $powersuit_bottom.find(".c-carousel-count__total").html(getdoubleDigestNumer(e)),
    n = new Swiper("#carousel-cart-powersuit_bottom .swiper-container",{
        setWrapperSize: !0,
        slidesPerView: 1,
        spaceBetween: 0,
        slidesOffsetAfter: 0,
        effect: "fade",
        loop: !0,
        speed: 400,
        navigation: {
            nextEl: "#carousel-cart-powersuit_bottom .c-carousel-navi-next",
            prevEl: "#carousel-cart-powersuit_bottom .c-carousel-navi-prev"
        }
    }),
    d = $powersuit_bottom.find(".c-carousel-count__current"),
    n.on("slideChange", function() {
        var e = getdoubleDigestNumer(n.realIndex + 1);
        d.html(e)
    }),
    1 == e && $powersuit_bottom.find("#swiper-navigation").addClass("is-hide"),
    v = $("#carousel-cart-bike").find("li").length,
    $("#carousel-cart-bike").find(".c-carousel-count__total").html(getdoubleDigestNumer(v)),
    l = new Swiper("#carousel-cart-bike .swiper-container",{
        setWrapperSize: !0,
        slidesPerView: 1,
        spaceBetween: 0,
        slidesOffsetAfter: 0,
        effect: "fade",
        loop: !0,
        speed: 400,
        navigation: {
            nextEl: "#carousel-cart-bike .c-carousel-navi-next",
            prevEl: "#carousel-cart-bike .c-carousel-navi-prev"
        }
    }),
    $b_current_target1 = $("#carousel-cart-bike").find(".c-carousel-count__current"),
    l.on("slideChange", function() {
        var e = getdoubleDigestNumer(l.realIndex + 1);
        $b_current_target1.html(e)
    }),
    1 == v && $("#carousel-cart-bike").find("#swiper-navigation").addClass("is-hide"),
    v = $("#carousel-cart-bike_ex").find("li").length,
    $("#carousel-cart-bike_ex").find(".c-carousel-count__total").html(getdoubleDigestNumer(v)),
    c = new Swiper("#carousel-cart-bike_ex .swiper-container",{
        setWrapperSize: !0,
        slidesPerView: 1,
        spaceBetween: 0,
        slidesOffsetAfter: 0,
        effect: "fade",
        loop: !0,
        speed: 400,
        navigation: {
            nextEl: "#carousel-cart-bike_ex .c-carousel-navi-next",
            prevEl: "#carousel-cart-bike_ex .c-carousel-navi-prev"
        }
    }),
    $b_current_target2 = $("#carousel-cart-bike_ex").find(".c-carousel-count__current"),
    c.on("slideChange", function() {
        var e = getdoubleDigestNumer(c.realIndex + 1);
        $b_current_target2.html(e)
    }),
    1 == v && $("#carousel-cart-bike_ex").find("#swiper-navigation").addClass("is-hide")),
    $("#start_home_gym").length && ($carousel_home_gym = $("#start_home_gym"),
    e = getdoubleDigestNumer($carousel_home_gym.find("li").length),
    $carousel_home_gym.find(".c-carousel-count__total").html(e),
    u = new Swiper("#carousel-home_gym .swiper-container",{
        setWrapperSize: !0,
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesOffsetAfter: 0,
        centeredSlides: !0,
        speed: 500,
        navigation: {
            nextEl: "#start_home_gym .c-carousel-navi-next",
            prevEl: "#start_home_gym .c-carousel-navi-prev"
        }
    }),
    d = $carousel_home_gym.find(".c-carousel-count__current"),
    u.on("slideChange", function() {
        var e = getdoubleDigestNumer(u.realIndex + 1);
        d.html(e)
    })),
    sixpad.visibleCheck = function() {
        var s = $window.scrollTop()
          , a = $window.height();
        $(".vc").each(function(e) {
            var t = jQuery(this)
              , i = t.offset().top;
            t.height();
            t.hasClass("slow") || (_offset = 100,
            window.innerWidth <= 768 && (_offset = -80)),
            s + a > i + _offset && (t.hasClass("is-visible") || (t.hasClass("is-hidden") && t.removeClass("is-hidden"),
            t.addClass("is-visible")))
        })
    }
    ,
    window.addEventListener("scroll", function() {
        throttle(sixpad.visibleCheck)
    }, {
        passive: !0
    }),
    document.addEventListener("wheel", function() {
        1 == isAnchorScroll && (anchorTarget.stop().velocity("stop"),
        isAnchorScroll = !1)
    });
    var _ = 0
      , w = $(window).width()
      , y = ($(window).height(),
    $("#product-powersuit-size-set.men").find(".product-powersuit-size-top").find(".size-detail"))
      , x = $("#product-powersuit-size-set.men").find(".product-powersuit-size-bottom").find(".size-detail")
      , C = $("#product-powersuit-size-set.women").find(".product-powersuit-size-top").find(".size-detail")
      , S = $("#product-powersuit-size-set.women").find(".product-powersuit-size-bottom").find(".size-detail");
    sixpad.onResize = function() {
        var e, t, i, s, a, r;
        $("body").hasClass("subscription") && (tableH = $("table").height(),
        tableTop = $("table").offset().top,
        trTop = $("table tr").eq(6).offset().top,
        tableCloseH = trTop - tableTop + 1,
        is_table ? $(".table-wrapper").height(tableH) : $(".table-wrapper").height(tableCloseH),
        t = e = 0,
        i = y.outerHeight(),
        s = x.outerHeight(),
        a = C.outerHeight(),
        r = S.outerHeight(),
        768 <= w ? (y.css("height", ""),
        x.css("height", ""),
        i = y.outerHeight(),
        s = x.outerHeight(),
        y.css("height", e = i < s ? s : i),
        x.css("height", e),
        C.css("height", ""),
        S.css("height", ""),
        a = C.outerHeight(),
        r = S.outerHeight(),
        C.css("height", t = a < r ? r : a),
        S.css("height", t)) : (y.css("height", ""),
        x.css("height", ""),
        C.css("height", ""),
        S.css("height", "")))
    }
    ,
    window.addEventListener("resize", function() {
        w = $(window).width(),
        $(window).height(),
        sixpad.onResize(),
        0 < _ && clearTimeout(_),
        _ = setTimeout(function() {
            sixpad.onResize()
        }, 100)
    })
}),
$(window).on("load", function() {
    function t(e) {
        e !== o && (s.removeClass(l),
        null !== e && s.eq(e).addClass(l),
        o = e)
    }
    var i, s, a, r, o, n, l, c, u, d;
    function e() {
        c = $(window).width();
        var e = .115625;
        n = c <= 768 ? 0 * $(window).width() : 769 <= c && c <= 1079 ? 124.875 : 1920 <= c ? 222 : e * $(window).width()
    }
    if ($("body").hasClass("thebike"),
    $("body").hasClass("faq") && (i = jQuery(window),
    r = [],
    o = null,
    n = 0,
    l = "current",
    $anchor = $("#faq-nav"),
    s = $anchor.find(".support-faq-nav-list__item"),
    a = s.length,
    s.each(function(e) {
        var t = jQuery(this).find("a").attr("href");
        r[e] = jQuery(t).offset().top - n,
        e === a - 1 && (r.end = jQuery(t).offset().top - n + jQuery(t).height())
    }),
    i.on("scroll", function() {
        !function() {
            for (var e = r.length - 1; 0 <= e; e--)
                if (i.scrollTop() >= r[e]) {
                    t(e);
                    break
                }
            (i.scrollTop() < r[0] || i.scrollTop() > r.end) && t(null)
        }(),
        s.each(function(e) {
            var t = jQuery(this).find("a").attr("href");
            r[e] = jQuery(t).offset().top - n,
            e === a - 1 && (r.end = jQuery(t).offset().top - n + jQuery(t).height())
        })
    }).trigger("scroll"),
    window.addEventListener("resize", function() {
        e()
    }),
    e(),
    $("#faq-nav-select").find("select").change(function() {
        var e = $(this).val();
        anchorScroll("#" + e)
    }),
    $(".support-faq-list__item").each(function() {
        var t = $(this);
        $(this).find(".support-faq-list__item__q").on("click", function() {
            var e;
            return t.hasClass("active") ? (t.removeClass("active"),
            t.find(".support-faq-list__item__a").css("max-height", "")) : (t.addClass("active"),
            e = t.find(".support-faq-list__item__a-inner").outerHeight(),
            t.find(".support-faq-list__item__a").css("max-height", e + 50)),
            !1
        })
    })),
    $("body").hasClass("guide") && $("#guide-nav-select").find("select").change(function() {
        var e = "#" + $(this).val();
        $("#guide-nav .guide-nav-list").removeClass("selected"),
        $(e).addClass("selected")
    }),
    $("body").hasClass("shop") && (p = !1,
    u = [],
    d = [],
    shopsearchEnable = function(e, t) {
        switch (p && ($(".shop-search-list__item").removeClass("is-enable"),
        p = !1),
        e) {
        case "area":
            0;
            break;
        case "service":
            0
        }
        "area" == e ? u.forEach(function(e) {
            $(".shop-search-list__item").each(function() {
                var t = $(this);
                -1 != t.data("area").indexOf(e) ? (0 == d.length && t.addClass("is-enable"),
                d.forEach(function(e) {
                    -1 != t.data("service").indexOf(e) && t.addClass("is-enable")
                })) : 0 != d.length && 1 == u.length && t.removeClass("is-enable")
            })
        }) : d.forEach(function(e) {
            $(".shop-search-list__item").each(function() {
                var t = $(this);
                -1 != t.data("service").indexOf(e) ? (0 == u.length && t.addClass("is-enable"),
                u.forEach(function(e) {
                    -1 != t.data("area").indexOf(e) && t.addClass("is-enable")
                })) : 0 != u.length && 1 == d.length && t.removeClass("is-enable")
            })
        })
    }
    ,
    shopsearchDisable = function(e, i) {
        0 != u.length || 0 != d ? ($(this),
        "area" == e ? 0 != u.length ? u.forEach(function(e) {
            $(".shop-search-list__item").each(function() {
                var t = $(this);
                -1 != t.data("area").indexOf(e) ? 0 != d.length ? d.forEach(function(e) {
                    -1 != t.data("service").indexOf(e) && t.addClass("is-enable")
                }) : t.addClass("is-enable") : t.data("area") == i && t.removeClass("is-enable")
            })
        }) : d.forEach(function(t) {
            $(".shop-search-list__item").each(function() {
                var e = $(this);
                -1 != e.data("service").indexOf(t) && e.addClass("is-enable")
            })
        }) : 0 != d.length ? d.forEach(function(e) {
            $(".shop-search-list__item").each(function() {
                var t = $(this);
                -1 != t.data("service").indexOf(e) ? 0 != u.length ? u.forEach(function(e) {
                    -1 != t.data("area").indexOf(e) && t.addClass("is-enable")
                }) : t.addClass("is-enable") : t.removeClass("is-enable")
            })
        }) : u.forEach(function(t) {
            $(".shop-search-list__item").each(function() {
                var e = $(this);
                -1 != e.data("area").indexOf(t) && e.addClass("is-enable")
            })
        })) : (p = !0,
        $(".shop-search-list__item").addClass("is-enable"))
    }
    ,
    $(".c-search-btn.area").on("click", function() {
        var e, t = $(this);
        t.hasClass("selected") ? (t.removeClass("selected"),
        e = u.indexOf(t.data("area")),
        u.splice(e, 1),
        shopsearchDisable("area", t.data("area"))) : (t.addClass("selected"),
        u.push(t.data("area")),
        shopsearchEnable("area"))
    }),
    $(".c-search-btn.service").on("click", function() {
        var e, t = $(this);
        t.hasClass("selected") ? (t.removeClass("selected"),
        e = d.indexOf(t.data("service")),
        d.splice(e, 1),
        shopsearchDisable("service", t.data("service"))) : (t.addClass("selected"),
        d.push(t.data("service")),
        shopsearchEnable("service"))
    }),
    shopsearchDisable("area")),
    $("body").hasClass("review")) {
        var p = !1
          , f = []
          , h = []
          , m = []
          , g = $(".review-search-list__item");
        reviewSearchEnable = function(e, t) {
            var r = f
              , o = h
              , n = m;
            cat1 = "gender",
            cat2 = "age",
            cat3 = "type",
            g.each(function() {
                var t = $(this)
                  , i = 0
                  , s = 0
                  , a = 0;
                0 != r.length || 0 != o.length || 0 != n.length ? (0 != r.length ? r.some(function(e) {
                    -1 != t.data(cat1).indexOf(e) ? (t.addClass("is-enable"),
                    i = 1) : 0 == i && t.removeClass("is-enable")
                }) : i = 1,
                0 != o.length ? o.some(function(e) {
                    -1 != t.data(cat2).indexOf(e) ? 1 == i && (t.addClass("is-enable"),
                    s = 1) : 0 != i && 0 != s || t.removeClass("is-enable")
                }) : s = 1,
                n.some(function(e) {
                    -1 != t.data(cat3).indexOf(e) ? 1 == i && 1 == s && (t.addClass("is-enable"),
                    a = 1) : 0 != i && 0 != s && 0 != a || t.removeClass("is-enable")
                })) : (p = !0,
                g.addClass("is-enable"))
            })
        }
        ;
        class _ {
            constructor(e, i, s) {
                $(e).on("click", function() {
                    var e, t = $(this);
                    t.hasClass("selected") ? (t.removeClass("selected"),
                    e = s.indexOf(t.data(i)),
                    s.splice(e, 1)) : (t.addClass("selected"),
                    s.push(t.data(i))),
                    reviewSearchEnable(i)
                })
            }
        }
        new _(".c-search-btn.gender","gender",f),
        new _(".c-search-btn.age","age",h),
        new _(".c-search-btn.type","type",m);
        reviewSearchEnable("gender")
    }
    if ($("body").hasClass("sizereview")) {
        var p = !1
          , f = []
          , v = []
          , b = []
          , g = $(".review-search-list__item");
        reviewSearchEnable = function(e, t) {
            var r = f
              , o = b
              , n = v;
            cat1 = "gender",
            cat2 = "tall",
            cat3 = "weight",
            g.each(function() {
                var t = $(this)
                  , i = 0
                  , s = 0
                  , a = 0;
                0 != r.length || 0 != n.length || 0 != o.length ? (0 != r.length ? r.some(function(e) {
                    -1 != t.data(cat1).indexOf(e) ? (t.addClass("is-enable"),
                    i = 1) : 0 == i && t.removeClass("is-enable")
                }) : i = 1,
                0 != n.length ? n.some(function(e) {
                    -1 != t.data(cat2).indexOf(e) ? 1 == i && (t.addClass("is-enable"),
                    s = 1) : 0 != i && 0 != s || t.removeClass("is-enable")
                }) : s = 1,
                o.some(function(e) {
                    -1 != t.data(cat3).indexOf(e) ? 1 == i && 1 == s && (t.addClass("is-enable"),
                    a = 1) : 0 != i && 0 != s && 0 != a || t.removeClass("is-enable")
                })) : (p = !0,
                g.addClass("is-enable"))
            })
        }
        ;
        class w {
            constructor(e, i, s) {
                $(e).on("click", function() {
                    var e, t = $(this);
                    t.hasClass("selected") ? (t.removeClass("selected"),
                    e = s.indexOf(t.data(i)),
                    s.splice(e, 1)) : (t.addClass("selected"),
                    s.push(t.data(i))),
                    reviewSearchEnable(i)
                })
            }
        }
        new w(".c-search-btn.gender","gender",f),
        new w(".c-search-btnss.tall","tall",v),
        new w(".c-search-btnss.weight","weight",b);
        reviewSearchEnable("gender")
    }
    $("body").hasClass("subscription") && (tableTop = $("table").offset().top,
    tableH = $("table").height(),
    trTop = $("table tr").eq(6).offset().top,
    tableCloseH = trTop - tableTop + 1,
    is_table || $(".table-wrapper").height(tableCloseH),
    tableOpen = function() {
        is_table = is_table ? ($(".ability-more").removeClass("is-open"),
        $(".table-wrapper").height(tableCloseH),
        !1) : ($(".ability-more").addClass("is-open"),
        $(".table-wrapper").height(tableH),
        !0)
    }
    ,
    $('input[name="powersuit"]').change(function() {
        var e = $('input[name="powersuit"]:checked').val();
        "Top/BottomSet" == e ? ($(".product-powersuit-size-top").removeClass("is-disable"),
        $(".product-powersuit-size-bottom").removeClass("is-disable"),
        $("#carousel-cart-powersuit_set").addClass("is-show"),
        $("#carousel-cart-powersuit_top").removeClass("is-show"),
        $("#carousel-cart-powersuit_bottom").removeClass("is-show")) : "Top" == e ? ($(".product-powersuit-size-top").removeClass("is-disable"),
        $(".product-powersuit-size-bottom").addClass("is-disable"),
        $("#carousel-cart-powersuit_set").removeClass("is-show"),
        $("#carousel-cart-powersuit_top").addClass("is-show"),
        $("#carousel-cart-powersuit_bottom").removeClass("is-show")) : "Bottom" == e && ($(".product-powersuit-size-top").addClass("is-disable"),
        $(".product-powersuit-size-bottom").removeClass("is-disable"),
        $("#carousel-cart-powersuit_set").removeClass("is-show"),
        $("#carousel-cart-powersuit_top").removeClass("is-show"),
        $("#carousel-cart-powersuit_bottom").addClass("is-show"))
    }),
    $('input[name="gender"]').change(function() {
        "MEN" == $('input[name="gender"]:checked').val() ? ($("#product-powersuit-size-set.men").addClass("is-show"),
        $("#product-powersuit-size-set.women").removeClass("is-show")) : ($("#product-powersuit-size-set.men").removeClass("is-show"),
        $("#product-powersuit-size-set.women").addClass("is-show"))
    }),
    $('input[name="bike"]').change(function() {
        var e, t = $('input[name="bike"]:checked').val();
        "The Bike" == t ? (e = "javascript:$$.Modal.show('thebike-spec')",
        $("#carousel-cart-bike").addClass("is-show"),
        $("#carousel-cart-bike_ex").removeClass("is-show"),
        $("#thebike-spec-modalbtn").attr("href", e)) : "The Bike Ex" == t && (e = "javascript:$$.Modal.show('thebike_ex-spec')",
        $("#carousel-cart-bike").removeClass("is-show"),
        $("#carousel-cart-bike_ex").addClass("is-show"),
        $("#thebike-spec-modalbtn").attr("href", e))
    }),
    $("#modal-simulation-powersuit").find(".subscription__simulation__buttons__item").click(function(e) {
        var t = $("#modal-simulation-powersuit").find(".subscription__simulation__buttons__item");
        t.removeClass("actived");
        var i = $(this)
          , t = t.index(this);
        i.addClass("actived");
        i = $("#modal-simulation-powersuit").find(".subscription__simulation__results").find(".subscription__simulation__results__item");
        i.removeClass("actived"),
        i.eq(t).addClass("actived")
    }),
    $("#modal-simulation-bike").find(".subscription__simulation__buttons__item").click(function(e) {
        var t = $("#modal-simulation-bike").find(".subscription__simulation__buttons__item");
        t.removeClass("actived");
        var i = $(this)
          , t = t.index(this);
        i.addClass("actived");
        i = $("#modal-simulation-bike").find(".subscription__simulation__results").find(".subscription__simulation__results__item");
        i.removeClass("actived"),
        i.eq(t).addClass("actived")
    })),
    sixpad.init = function() {
        var s;
        $$.pageReadySignal.dispatch(),
        sixpad.btnMouseEvent = function() {
            for (var e = document.getElementsByClassName("link"), t = 0; t < e.length; t++)
                e[t].addEventListener("mouseenter", function() {
                    this.classList.add("hover")
                }),
                e[t].addEventListener("mouseleave", function() {
                    this.classList.remove("hover")
                }),
                e[t].addEventListener("touchstart", function() {
                    this.classList.add("hover")
                }),
                e[t].addEventListener("touchend", function() {
                    this.classList.remove("hover")
                });
            document.getElementsByTagName("body")[0].addEventListener("touchend", function() {
                $(".link").removeClass("hover")
            })
        }
        ,
        sixpad.btnMouseEvent(),
        $('a[href^="#"]').click(function() {
            var e = $(this).attr("href");
            return anchorScroll(e, 1200),
            !1
        }),
        anchorScroll = function(e, t) {
            if (s = $("#" === e || "" === e ? "html" : e),
            !Object.keys(s).length)
                return !1;
            var i = $(window).width();
            s.offset().top;
            _offset = $("body").hasClass("lp_page") ? i <= 768 ? -69 / 414 * $(window).width() : 0 : (e = -.1125,
            i <= 768 ? -110 / 414 * $(window).width() : 769 <= i && i <= 1079 ? -121.5 : 1920 <= i ? -216 : e * $(window).width()),
            s.velocity("scroll", {
                offset: _offset,
                duration: t,
                easing: "easeInOutQuart",
                begin: function() {
                    isAnchorScroll = !0
                },
                complete: function() {
                    isAnchorScroll = !1
                }
            })
        }
        ;
        var e = location.hash;
        e && ($("body,html").stop().scrollTop(0),
        setTimeout(anchorScroll(e, 800), 400))
    }
    ,
    sixpad.init(),
    setTimeout(sixpad.contentStart, 200)
}),
sixpad.contentStart = function() {
    jQuery("body").removeClass("loading"),
    jQuery("body").addClass("loadcomplete"),
    sixpad.onResize(),
    sixpad.visibleCheck()
}
,
$("body").hasClass("add") && (getdoubleDigestNumer = function(e) {
    return ("0" + e).slice(-2)
}
,
$(".add .add-content .list-item .item-img a").on("click", function() {
    var s = $(this).attr("data-btn");
    setTimeout(function() {
        $(".carousel-detail-product").length && $(".carousel-detail-product").each(function() {
            $(this);
            var t = s
              , e = $(".carousel-detail-product" + t)
              , i = new Swiper(e,{
                spaceBetween: 0,
                effect: "fade",
                slidesOffsetAfter: 0,
                loop: !0,
                speed: 500,
                navigation: {
                    nextEl: ".carousel-detail-product" + t + " .c-carousel-navi-next",
                    prevEl: ".carousel-detail-product" + t + " .c-carousel-navi-prev"
                }
            })
              , e = i.slides.length - 2;
            e = e < 10 ? "0" + e : e,
            $(".carousel-detail-product" + t).find(".c-carousel-count__total").html(e),
            $(".carousel-detail-product" + t).find(".c-carousel-count__current").html("01"),
            i.on("slideChange", function() {
                var e;
                currentCount_subsc = i.realIndex + 1,
                e = currentCount_subsc < 10 ? "0" + currentCount_subsc : currentCount_subsc,
                $(".carousel-detail-product" + t).find(".c-carousel-count__current").html(e)
            })
        })
    }, 200)
})),
$("body").hasClass("detail") && (getdoubleDigestNumer = function(e) {
    return ("0" + e).slice(-2)
}
,
$(".carousel-img-product").length && $(".carousel-img-product").each(function() {
    var t = $(this).attr("data-gslide")
      , e = $(".carousel-img-product" + t)
      , i = getdoubleDigestNumer($(".carousel-img-product" + t).find(".product-slide-item").length);
    $(".carousel-img-product" + t).find(".c-carousel-count__total").html(i);
    var s = new Swiper(e,{
        spaceBetween: 0,
        effect: "fade",
        slidesOffsetAfter: 0,
        loop: !0,
        speed: 500,
        navigation: {
            nextEl: ".carousel-img-product" + t + " .c-carousel-navi-next",
            prevEl: ".carousel-img-product" + t + " .c-carousel-navi-prev"
        }
    });
    s.on("slideChange", function() {
        var e = getdoubleDigestNumer(s.realIndex + 1);
        $(".carousel-img-product" + t).find(".c-carousel-count__current").html(e)
    })
}),
$(".carousel-detail-product").length && $(".carousel-detail-product").each(function() {
    var t = $(this).attr("data-detail-slide")
      , e = $(".carousel-detail-product" + t)
      , i = getdoubleDigestNumer($(".carousel-detail-product" + t).find(".detail-slide-item").length);
    $(".carousel-detail-product" + t).find(".c-carousel-count__total").html(i);
    var s = new Swiper(e,{
        spaceBetween: 0,
        effect: "fade",
        slidesOffsetAfter: 0,
        loop: !0,
        speed: 500,
        navigation: {
            nextEl: ".carousel-detail-product" + t + " .c-carousel-navi-next",
            prevEl: ".carousel-detail-product" + t + " .c-carousel-navi-prev"
        }
    });
    s.on("slideChange", function() {
        var e = getdoubleDigestNumer(s.realIndex + 1);
        $(".carousel-detail-product" + t).find(".c-carousel-count__current").html(e)
    })
})),
$("body").hasClass("apply") && (getdoubleDigestNumer = function(e) {
    return ("0" + e).slice(-2)
}
,
$(".apply .sec-item .list-item .item-img a").on("click", function() {
    var s = $(this).attr("data-btn");
    setTimeout(function() {
        $(".carousel-detail-product").length && $(".carousel-detail-product").each(function() {
            $(this);
            var t = s
              , e = $(".carousel-detail-product" + t)
              , i = new Swiper(e,{
                spaceBetween: 0,
                effect: "fade",
                slidesOffsetAfter: 0,
                loop: !0,
                speed: 500,
                navigation: {
                    nextEl: ".carousel-detail-product" + t + " .c-carousel-navi-next",
                    prevEl: ".carousel-detail-product" + t + " .c-carousel-navi-prev"
                }
            })
              , e = i.slides.length - 2;
            e = e < 10 ? "0" + e : e,
            $(".carousel-detail-product" + t).find(".c-carousel-count__total").html(e),
            $(".carousel-detail-product" + t).find(".c-carousel-count__current").html("01"),
            i.on("slideChange", function() {
                var e = i.realIndex + 1;
                e = e < 10 ? "0" + e : e,
                $(".carousel-detail-product" + t).find(".c-carousel-count__current").html(e)
            })
        })
    }, 200)
}),
$("body").hasClass("apply") && ($('input[name="gender"]').change(function() {
    "MEN" == $('input[name="gender"]:checked').val() ? ($("#product-powersuit-size-set.men").addClass("is-show"),
    $("#product-powersuit-size-set.women").removeClass("is-show")) : ($("#product-powersuit-size-set.men").removeClass("is-show"),
    $("#product-powersuit-size-set.women").addClass("is-show"))
}),
$('input[name="powersuit"]').change(function() {
    var e = $('input[name="powersuit"]:checked').val();
    "Top/BottomSet" == e ? ($(".product-powersuit-size-top").removeClass("is-disable"),
    $(".product-powersuit-size-bottom").removeClass("is-disable"),
    $("#carousel-cart-powersuit_set").addClass("is-show"),
    $("#carousel-cart-powersuit_top").removeClass("is-show"),
    $("#carousel-cart-powersuit_bottom").removeClass("is-show")) : "Top" == e ? ($(".product-powersuit-size-top").removeClass("is-disable"),
    $(".product-powersuit-size-bottom").addClass("is-disable"),
    $("#carousel-cart-powersuit_set").removeClass("is-show"),
    $("#carousel-cart-powersuit_top").addClass("is-show"),
    $("#carousel-cart-powersuit_bottom").removeClass("is-show")) : "Bottom" == e && ($(".product-powersuit-size-top").addClass("is-disable"),
    $(".product-powersuit-size-bottom").removeClass("is-disable"),
    $("#carousel-cart-powersuit_set").removeClass("is-show"),
    $("#carousel-cart-powersuit_top").removeClass("is-show"),
    $("#carousel-cart-powersuit_bottom").addClass("is-show"))
}),
$('input[name="bike-type"]').change(function() {
    var e, t = $(this).val();
    "the bike" == t ? (e = "javascript:$$.Modal.show('thebike-spec')",
    $("#carousel-cart-bike").addClass("is-show"),
    $("#carousel-cart-bike_ex").removeClass("is-show"),
    $("#thebike-spec-modalbtn").attr("href", e)) : "the bike EX" == t && (e = "javascript:$$.Modal.show('thebike-ex-spec')",
    $("#carousel-cart-bike").removeClass("is-show"),
    $("#carousel-cart-bike_ex").addClass("is-show"),
    $("#thebike-spec-modalbtn").attr("href", e))
}),
$('input[name="bike-type"]').change(function() {
    var e, t = $('input[name="bike-type"]:checked').val();
    "the bike" == t ? (e = "javascript:$$.Modal.show('simulation-bike')",
    $("#bike-simulation-modalbtn").attr("href", e)) : "the bike EX" == t && (e = "javascript:$$.Modal.show('simulation-bikeex')",
    $("#bike-simulation-modalbtn").attr("href", e))
}),
$('input[name="powersuit"]').change(function() {
    var e, t = $('input[name="powersuit"]:checked').val();
    "Top/Bottomset" == t ? (e = "javascript:$$.Modal.show('simulation-powersuit')",
    $("#ps-simulation-modalbtn").attr("href", e)) : "Top" == t ? (e = "javascript:$$.Modal.show('simulation-powersuit-top')",
    $("#ps-simulation-modalbtn").attr("href", e)) : "Bottom" == t && (e = "javascript:$$.Modal.show('simulation-powersuit-bottom')",
    $("#ps-simulation-modalbtn").attr("href", e))
}),
$("#modal-simulation-powersuit").find(".subscription__simulation__buttons__item").click(function(e) {
    var t = $("#modal-simulation-powersuit").find(".subscription__simulation__buttons__item");
    t.removeClass("actived");
    var i = $(this)
      , t = t.index(this);
    i.addClass("actived");
    i = $("#modal-simulation-powersuit").find(".subscription__simulation__results").find(".subscription__simulation__results__item");
    i.removeClass("actived"),
    i.eq(t).addClass("actived")
}),
$("#modal-simulation-powersuit-top").find(".subscription__simulation__buttons__item").click(function(e) {
    var t = $("#modal-simulation-powersuit-top").find(".subscription__simulation__buttons__item");
    t.removeClass("actived");
    var i = $(this)
      , t = t.index(this);
    i.addClass("actived");
    i = $("#modal-simulation-powersuit-top").find(".subscription__simulation__results").find(".subscription__simulation__results__item");
    i.removeClass("actived"),
    i.eq(t).addClass("actived")
}),
$("#modal-simulation-powersuit-bottom").find(".subscription__simulation__buttons__item").click(function(e) {
    var t = $("#modal-simulation-powersuit-bottom").find(".subscription__simulation__buttons__item");
    t.removeClass("actived");
    var i = $(this)
      , t = t.index(this);
    i.addClass("actived");
    i = $("#modal-simulation-powersuit-bottom").find(".subscription__simulation__results").find(".subscription__simulation__results__item");
    i.removeClass("actived"),
    i.eq(t).addClass("actived")
}),
$("#modal-simulation-bike").find(".subscription__simulation__buttons__item").click(function(e) {
    var t = $("#modal-simulation-bike").find(".subscription__simulation__buttons__item");
    t.removeClass("actived");
    var i = $(this)
      , t = t.index(this);
    i.addClass("actived");
    i = $("#modal-simulation-bike").find(".subscription__simulation__results").find(".subscription__simulation__results__item");
    i.removeClass("actived"),
    i.eq(t).addClass("actived")
}),
$("#modal-simulation-bikeex").find(".subscription__simulation__buttons__item").click(function(e) {
    var t = $("#modal-simulation-bikeex").find(".subscription__simulation__buttons__item");
    t.removeClass("actived");
    var i = $(this)
      , t = t.index(this);
    i.addClass("actived");
    i = $("#modal-simulation-bikeex").find(".subscription__simulation__results").find(".subscription__simulation__results__item");
    i.removeClass("actived"),
    i.eq(t).addClass("actived")
}),
$("#modal-simulation-set2212a").find(".subscription__simulation__buttons__item").click(function(e) {
    var t = $("#modal-simulation-set2212a").find(".subscription__simulation__buttons__item");
    t.removeClass("actived");
    var i = $(this)
      , t = t.index(this);
    i.addClass("actived");
    i = $("#modal-simulation-set2212a").find(".subscription__simulation__results").find(".subscription__simulation__results__item");
    i.removeClass("actived"),
    i.eq(t).addClass("actived")
}),
$("#modal-simulation-set2212b").find(".subscription__simulation__buttons__item").click(function(e) {
    var t = $("#modal-simulation-set2212b").find(".subscription__simulation__buttons__item");
    t.removeClass("actived");
    var i = $(this)
      , t = t.index(this);
    i.addClass("actived");
    i = $("#modal-simulation-set2212b").find(".subscription__simulation__results").find(".subscription__simulation__results__item");
    i.removeClass("actived"),
    i.eq(t).addClass("actived")
}))),
function(t) {
    function n(e) {
        var t = e.length
          , i = c.type(e);
        return "function" !== i && !c.isWindow(e) && (!(1 !== e.nodeType || !t) || ("array" === i || 0 === t || "number" == typeof t && 0 < t && t - 1 in e))
    }
    if (!t.jQuery) {
        function c(e, t) {
            return new c.fn.init(e,t)
        }
        c.isWindow = function(e) {
            return null != e && e == e.window
        }
        ,
        c.type = function(e) {
            return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? i[a.call(e)] || "object" : typeof e
        }
        ,
        c.isArray = Array.isArray || function(e) {
            return "array" === c.type(e)
        }
        ,
        c.isPlainObject = function(e) {
            if (!e || "object" !== c.type(e) || e.nodeType || c.isWindow(e))
                return !1;
            try {
                if (e.constructor && !s.call(e, "constructor") && !s.call(e.constructor.prototype, "isPrototypeOf"))
                    return !1
            } catch (e) {
                return !1
            }
            for (var t in e)
                ;
            return void 0 === t || s.call(e, t)
        }
        ,
        c.each = function(e, t, i) {
            var s, a = 0, r = e.length, o = n(e);
            if (i) {
                if (o)
                    for (; a < r && !1 !== (s = t.apply(e[a], i)); a++)
                        ;
                else
                    for (a in e)
                        if (s = t.apply(e[a], i),
                        !1 === s)
                            break
            } else if (o)
                for (; a < r && !1 !== (s = t.call(e[a], a, e[a])); a++)
                    ;
            else
                for (a in e)
                    if (s = t.call(e[a], a, e[a]),
                    !1 === s)
                        break;
            return e
        }
        ,
        c.data = function(e, t, i) {
            if (void 0 === i) {
                var s = (a = e[c.expando]) && r[a];
                return void 0 === t ? s : s && t in s ? s[t] : void 0
            }
            if (void 0 !== t) {
                var a = e[c.expando] || (e[c.expando] = ++c.uuid);
                return r[a] = r[a] || {},
                r[a][t] = i
            }
        }
        ,
        c.removeData = function(e, t) {
            var e = e[c.expando]
              , i = e && r[e];
            i && c.each(t, function(e, t) {
                delete i[t]
            })
        }
        ,
        c.extend = function() {
            var e, t, i, s, a, r = arguments[0] || {}, o = 1, n = arguments.length, l = !1;
            for ("boolean" == typeof r && (l = r,
            r = arguments[o] || {},
            o++),
            "object" != typeof r && "function" !== c.type(r) && (r = {}),
            o === n && (r = this,
            o--); o < n; o++)
                if (null != (s = arguments[o]))
                    for (i in s)
                        a = r[i],
                        t = s[i],
                        r !== t && (l && t && (c.isPlainObject(t) || (e = c.isArray(t))) ? (a = e ? (e = !1,
                        a && c.isArray(a) ? a : []) : a && c.isPlainObject(a) ? a : {},
                        r[i] = c.extend(l, a, t)) : void 0 !== t && (r[i] = t));
            return r
        }
        ,
        c.queue = function(e, t, i) {
            function s(e, t) {
                t = t || [];
                return null != e && (n(Object(e)) ? function(e, t) {
                    for (var i = +t.length, s = 0, a = e.length; s < i; )
                        e[a++] = t[s++];
                    if (i != i)
                        for (; void 0 !== t[s]; )
                            e[a++] = t[s++];
                    e.length = a
                }(t, "string" == typeof e ? [e] : e) : [].push.call(t, e)),
                t
            }
            if (e) {
                var a = c.data(e, t = (t || "fx") + "queue");
                return i ? (!a || c.isArray(i) ? a = c.data(e, t, s(i)) : a.push(i),
                a) : a || []
            }
        }
        ,
        c.dequeue = function(e, a) {
            c.each(e.nodeType ? [e] : e, function(e, t) {
                a = a || "fx";
                var i = c.queue(t, a)
                  , s = i.shift();
                (s = "inprogress" === s ? i.shift() : s) && ("fx" === a && i.unshift("inprogress"),
                s.call(t, function() {
                    c.dequeue(t, a)
                }))
            })
        }
        ,
        c.fn = c.prototype = {
            init: function(e) {
                if (e.nodeType)
                    return this[0] = e,
                    this;
                throw new Error("Not a DOM node.")
            },
            offset: function() {
                var e = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {
                    top: 0,
                    left: 0
                };
                return {
                    top: e.top + (t.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
                    left: e.left + (t.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
                }
            },
            position: function() {
                function e() {
                    for (var e = this.offsetParent || document; e && "html" === !e.nodeType.toLowerCase && "static" === e.style.position; )
                        e = e.offsetParent;
                    return e || document
                }
                var t = this[0]
                  , e = e.apply(t)
                  , i = this.offset()
                  , s = /^(?:body|html)$/i.test(e.nodeName) ? {
                    top: 0,
                    left: 0
                } : c(e).offset();
                return i.top -= parseFloat(t.style.marginTop) || 0,
                i.left -= parseFloat(t.style.marginLeft) || 0,
                e.style && (s.top += parseFloat(e.style.borderTopWidth) || 0,
                s.left += parseFloat(e.style.borderLeftWidth) || 0),
                {
                    top: i.top - s.top,
                    left: i.left - s.left
                }
            }
        };
        var r = {};
        c.expando = "velocity" + (new Date).getTime(),
        c.uuid = 0;
        for (var i = {}, s = i.hasOwnProperty, a = i.toString, e = "Boolean Number String Function Array Date RegExp Object Error".split(" "), o = 0; o < e.length; o++)
            i["[object " + e[o] + "]"] = e[o].toLowerCase();
        c.fn.init.prototype = c.fn,
        t.Velocity = {
            Utilities: c
        }
    }
}(window),
function(e) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : e()
}(function() {
    return function(e, O, q, j) {
        function m(e) {
            return B.isWrapped(e) ? e = [].slice.call(e) : B.isNode(e) && (e = [e]),
            e
        }
        function H(e) {
            e = D.data(e, "velocity");
            return null === e ? j : e
        }
        function s(o, t, n, i) {
            function s(e, t) {
                return 1 - 3 * t + 3 * e
            }
            function l(e, t, i) {
                return ((s(t, i) * e + (3 * i - 6 * t)) * e + 3 * t) * e
            }
            function c(e, t, i) {
                return 3 * s(t, i) * e * e + 2 * (3 * i - 6 * t) * e + 3 * t
            }
            function a(e) {
                for (var t = 0, i = 1, s = h - 1; i != s && b[i] <= e; ++i)
                    t += m;
                var a = t + (e - b[--i]) / (b[i + 1] - b[i]) * m
                  , r = c(a, o, n);
                return d <= r ? function(e, t) {
                    for (var i = 0; i < u; ++i) {
                        var s = c(t, o, n);
                        if (0 === s)
                            return t;
                        t -= (l(t, o, n) - e) / s
                    }
                    return t
                }(e, a) : 0 == r ? a : function(e, t, i) {
                    for (var s, a, r = 0; 0 < (s = l(a = t + (i - t) / 2, o, n) - e) ? i = a : t = a,
                    Math.abs(s) > p && ++r < f; )
                        ;
                    return a
                }(e, t, t + m)
            }
            function r() {
                _ = !0,
                o == t && n == i || function() {
                    for (var e = 0; e < h; ++e)
                        b[e] = l(e * m, o, n)
                }()
            }
            var u = 4
              , d = .001
              , p = 1e-7
              , f = 10
              , h = 11
              , m = 1 / (h - 1)
              , e = "Float32Array"in O;
            if (4 !== arguments.length)
                return !1;
            for (var g = 0; g < 4; ++g)
                if ("number" != typeof arguments[g] || isNaN(arguments[g]) || !isFinite(arguments[g]))
                    return !1;
            o = Math.min(o, 1),
            n = Math.min(n, 1),
            o = Math.max(o, 0),
            n = Math.max(n, 0);
            function v(e) {
                return _ || r(),
                o === t && n === i ? e : 0 === e ? 0 : 1 === e ? 1 : l(a(e), t, i)
            }
            var b = new (e ? Float32Array : Array)(h)
              , _ = !1;
            v.getControlPoints = function() {
                return [{
                    x: o,
                    y: t
                }, {
                    x: n,
                    y: i
                }]
            }
            ;
            var w = "generateBezier(" + [o, t, n, i] + ")";
            return v.toString = function() {
                return w
            }
            ,
            v
        }
        function F(e, t) {
            var i = e;
            return B.isString(e) ? I.Easings[e] || (i = !1) : i = B.isArray(e) && 1 === e.length ? function(t) {
                return function(e) {
                    return Math.round(e * t) * (1 / t)
                }
            }
            .apply(null, e) : B.isArray(e) && 2 === e.length ? o.apply(null, e.concat([t])) : !(!B.isArray(e) || 4 !== e.length) && s.apply(null, e),
            i = !1 === i ? I.Easings[I.defaults.easing] ? I.defaults.easing : r : i
        }
        function L(e) {
            if (e) {
                var t = (new Date).getTime()
                  , i = I.State.calls.length;
                1e4 < i && (I.State.calls = function(e) {
                    for (var t = -1, i = e ? e.length : 0, s = []; ++t < i; ) {
                        var a = e[t];
                        a && s.push(a)
                    }
                    return s
                }(I.State.calls));
                for (var s = 0; s < i; s++)
                    if (I.State.calls[s]) {
                        for (var a = I.State.calls[s], r = a[0], o = a[2], n = !!(c = a[3]), l = null, c = c || (I.State.calls[s][3] = t - 16), u = Math.min((t - c) / o.duration, 1), d = 0, p = r.length; d < p; d++) {
                            var f = r[d]
                              , h = f.element;
                            if (H(h)) {
                                var m, g = !1;
                                for (m in o.display !== j && null !== o.display && "none" !== o.display && ("flex" === o.display && D.each(["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"], function(e, t) {
                                    R.setPropertyValue(h, "display", t)
                                }),
                                R.setPropertyValue(h, "display", o.display)),
                                o.visibility !== j && "hidden" !== o.visibility && R.setPropertyValue(h, "visibility", o.visibility),
                                f)
                                    if ("element" !== m) {
                                        var v, b = f[m], _ = B.isString(b.easing) ? I.Easings[b.easing] : b.easing;
                                        if (1 === u)
                                            y = b.endValue;
                                        else {
                                            var w = b.endValue - b.startValue
                                              , y = b.startValue + w * _(u, o, w);
                                            if (!n && y === b.currentValue)
                                                continue
                                        }
                                        b.currentValue = y,
                                        "tween" === m ? l = y : (R.Hooks.registered[m] && (v = R.Hooks.getRoot(m),
                                        (w = H(h).rootPropertyValueCache[v]) && (b.rootPropertyValue = w)),
                                        b = R.setPropertyValue(h, m, b.currentValue + (0 === parseFloat(y) ? "" : b.unitType), b.rootPropertyValue, b.scrollData),
                                        R.Hooks.registered[m] && (H(h).rootPropertyValueCache[v] = R.Normalizations.registered[v] ? R.Normalizations.registered[v]("extract", null, b[1]) : b[1]),
                                        "transform" === b[0] && (g = !0))
                                    }
                                o.mobileHA && H(h).transformCache.translate3d === j && (H(h).transformCache.translate3d = "(0px, 0px, 0px)",
                                g = !0),
                                g && R.flushTransformCache(h)
                            }
                        }
                        o.display !== j && "none" !== o.display && (I.State.calls[s][2].display = !1),
                        o.visibility !== j && "hidden" !== o.visibility && (I.State.calls[s][2].visibility = !1),
                        o.progress && o.progress.call(a[1], a[1], u, Math.max(0, c + o.duration - t), c, l),
                        1 === u && $(s)
                    }
            }
            I.State.isTicking && x(L)
        }
        function $(e, t) {
            if (I.State.calls[e]) {
                for (var i = I.State.calls[e][0], s = I.State.calls[e][1], a = I.State.calls[e][2], r = I.State.calls[e][4], o = !1, n = 0, l = i.length; n < l; n++) {
                    var c, u = i[n].element;
                    if (t || a.loop || ("none" === a.display && R.setPropertyValue(u, "display", a.display),
                    "hidden" === a.visibility && R.setPropertyValue(u, "visibility", a.visibility)),
                    !0 === a.loop || D.queue(u)[1] !== j && /\.velocityQueueEntryFlag/i.test(D.queue(u)[1]) || !H(u) || (H(u).isAnimating = !1,
                    c = !(H(u).rootPropertyValueCache = {}),
                    D.each(R.Lists.transforms3D, function(e, t) {
                        var i = /^scale/.test(t) ? 1 : 0
                          , s = H(u).transformCache[t];
                        H(u).transformCache[t] !== j && new RegExp("^\\(" + i + "[^.]").test(s) && (c = !0,
                        delete H(u).transformCache[t])
                    }),
                    a.mobileHA && (c = !0,
                    delete H(u).transformCache.translate3d),
                    c && R.flushTransformCache(u),
                    R.Values.removeClass(u, "velocity-animating")),
                    !t && a.complete && !a.loop && n === l - 1)
                        try {
                            a.complete.call(s, s)
                        } catch (e) {
                            setTimeout(function() {
                                throw e
                            }, 1)
                        }
                    r && !0 !== a.loop && r(s),
                    H(u) && !0 === a.loop && !t && (D.each(H(u).tweensContainer, function(e, t) {
                        /^rotate/.test(e) && 360 === parseFloat(t.endValue) && (t.endValue = 0,
                        t.startValue = 360),
                        /^backgroundPosition/.test(e) && 100 === parseFloat(t.endValue) && "%" === t.unitType && (t.endValue = 0,
                        t.startValue = 100)
                    }),
                    I(u, "reverse", {
                        loop: !0,
                        delay: a.delay
                    })),
                    !1 !== a.queue && D.dequeue(u, a.queue)
                }
                I.State.calls[e] = !1;
                for (var d = 0, p = I.State.calls.length; d < p; d++)
                    if (!1 !== I.State.calls[d]) {
                        o = !0;
                        break
                    }
                !1 === o && (I.State.isTicking = !1,
                delete I.State.calls,
                I.State.calls = [])
            }
        }
        var D, a, c = function() {
            if (q.documentMode)
                return q.documentMode;
            for (var e = 7; 4 < e; e--) {
                var t = q.createElement("div");
                if (t.innerHTML = "\x3c!--[if IE " + e + "]><span></span><![endif]--\x3e",
                t.getElementsByTagName("span").length)
                    return t = null,
                    e
            }
            return j
        }(), t = (a = 0,
        O.webkitRequestAnimationFrame || O.mozRequestAnimationFrame || function(e) {
            var t = (new Date).getTime()
              , i = Math.max(0, 16 - (t - a));
            return a = t + i,
            setTimeout(function() {
                e(t + i)
            }, i)
        }
        ), B = {
            isString: function(e) {
                return "string" == typeof e
            },
            isArray: Array.isArray || function(e) {
                return "[object Array]" === Object.prototype.toString.call(e)
            }
            ,
            isFunction: function(e) {
                return "[object Function]" === Object.prototype.toString.call(e)
            },
            isNode: function(e) {
                return e && e.nodeType
            },
            isNodeList: function(e) {
                return "object" == typeof e && /^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(e)) && e.length !== j && (0 === e.length || "object" == typeof e[0] && 0 < e[0].nodeType)
            },
            isWrapped: function(e) {
                return e && (e.jquery || O.Zepto && O.Zepto.zepto.isZ(e))
            },
            isSVG: function(e) {
                return O.SVGElement && e instanceof O.SVGElement
            },
            isEmptyObject: function(e) {
                for (var t in e)
                    return !1;
                return !0
            }
        }, i = !1;
        if (e.fn && e.fn.jquery ? (D = e,
        i = !0) : D = O.Velocity.Utilities,
        c <= 8 && !i)
            throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
        if (!(c <= 7)) {
            var r = "swing"
              , I = {
                State: {
                    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
                    isAndroid: /Android/i.test(navigator.userAgent),
                    isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
                    isChrome: O.chrome,
                    isFirefox: /Firefox/i.test(navigator.userAgent),
                    prefixElement: q.createElement("div"),
                    prefixMatches: {},
                    scrollAnchor: null,
                    scrollPropertyLeft: null,
                    scrollPropertyTop: null,
                    isTicking: !1,
                    calls: []
                },
                CSS: {},
                Utilities: D,
                Redirects: {},
                Easings: {},
                Promise: O.Promise,
                defaults: {
                    queue: "",
                    duration: 400,
                    easing: r,
                    begin: j,
                    complete: j,
                    progress: j,
                    display: j,
                    visibility: j,
                    loop: !1,
                    delay: !1,
                    mobileHA: !0,
                    _cacheValues: !0
                },
                init: function(e) {
                    D.data(e, "velocity", {
                        isSVG: B.isSVG(e),
                        isAnimating: !1,
                        computedStyle: null,
                        tweensContainer: null,
                        rootPropertyValueCache: {},
                        transformCache: {}
                    })
                },
                hook: null,
                mock: !1,
                version: {
                    major: 1,
                    minor: 2,
                    patch: 2
                },
                debug: !1
            };
            O.pageYOffset !== j ? (I.State.scrollAnchor = O,
            I.State.scrollPropertyLeft = "pageXOffset",
            I.State.scrollPropertyTop = "pageYOffset") : (I.State.scrollAnchor = q.documentElement || q.body.parentNode || q.body,
            I.State.scrollPropertyLeft = "scrollLeft",
            I.State.scrollPropertyTop = "scrollTop");
            var o = function e(t, i, s) {
                var a, r, o, n, l, c, u, d, p, f, h = {
                    x: -1,
                    v: 0,
                    tension: null,
                    friction: null
                }, m = [0], g = 0;
                for (t = parseFloat(t) || 500,
                i = parseFloat(i) || 20,
                s = s || null,
                h.tension = t,
                h.friction = i,
                r = (a = null !== s) ? (g = e(t, i)) / s * .016 : .016; l = r,
                p = f = p = d = u = c = void 0,
                c = {
                    dx: (n = o || h).v,
                    dv: v(n)
                },
                u = b(n, .5 * l, c),
                d = b(n, .5 * l, u),
                p = b(n, l, d),
                f = 1 / 6 * (c.dx + 2 * (u.dx + d.dx) + p.dx),
                p = 1 / 6 * (c.dv + 2 * (u.dv + d.dv) + p.dv),
                n.x = n.x + f * l,
                n.v = n.v + p * l,
                m.push(1 + (o = n).x),
                g += 16,
                1e-4 < Math.abs(o.x) && 1e-4 < Math.abs(o.v); )
                    ;
                return a ? function(e) {
                    return m[e * (m.length - 1) | 0]
                }
                : g
            };
            I.Easings = {
                linear: function(e) {
                    return e
                },
                swing: function(e) {
                    return .5 - Math.cos(e * Math.PI) / 2
                },
                spring: function(e) {
                    return 1 - Math.cos(4.5 * e * Math.PI) * Math.exp(6 * -e)
                }
            },
            D.each([["ease", [.25, .1, .25, 1]], ["ease-in", [.42, 0, 1, 1]], ["ease-out", [0, 0, .58, 1]], ["ease-in-out", [.42, 0, .58, 1]], ["easeInSine", [.47, 0, .745, .715]], ["easeOutSine", [.39, .575, .565, 1]], ["easeInOutSine", [.445, .05, .55, .95]], ["easeInQuad", [.55, .085, .68, .53]], ["easeOutQuad", [.25, .46, .45, .94]], ["easeInOutQuad", [.455, .03, .515, .955]], ["easeInCubic", [.55, .055, .675, .19]], ["easeOutCubic", [.215, .61, .355, 1]], ["easeInOutCubic", [.645, .045, .355, 1]], ["easeInQuart", [.895, .03, .685, .22]], ["easeOutQuart", [.165, .84, .44, 1]], ["easeInOutQuart", [.77, 0, .175, 1]], ["easeInQuint", [.755, .05, .855, .06]], ["easeOutQuint", [.23, 1, .32, 1]], ["easeInOutQuint", [.86, 0, .07, 1]], ["easeInExpo", [.95, .05, .795, .035]], ["easeOutExpo", [.19, 1, .22, 1]], ["easeInOutExpo", [1, 0, 0, 1]], ["easeInCirc", [.6, .04, .98, .335]], ["easeOutCirc", [.075, .82, .165, 1]], ["easeInOutCirc", [.785, .135, .15, .86]]], function(e, t) {
                I.Easings[t[0]] = s.apply(null, t[1])
            });
            var R = I.CSS = {
                RegEx: {
                    isHex: /^#([A-f\d]{3}){1,2}$/i,
                    valueUnwrap: /^[A-z]+\((.*)\)$/i,
                    wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
                    valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi
                },
                Lists: {
                    colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
                    transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
                    transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"]
                },
                Hooks: {
                    templates: {
                        textShadow: ["Color X Y Blur", "black 0px 0px 0px"],
                        boxShadow: ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
                        clip: ["Top Right Bottom Left", "0px 0px 0px 0px"],
                        backgroundPosition: ["X Y", "0% 0%"],
                        transformOrigin: ["X Y Z", "50% 50% 0px"],
                        perspectiveOrigin: ["X Y", "50% 50%"]
                    },
                    registered: {},
                    register: function() {
                        for (var e, t = 0; t < R.Lists.colors.length; t++) {
                            var i = "color" === R.Lists.colors[t] ? "0 0 0 1" : "255 255 255 1";
                            R.Hooks.templates[R.Lists.colors[t]] = ["Red Green Blue Alpha", i]
                        }
                        if (c)
                            for (e in R.Hooks.templates) {
                                var s, a = (s = R.Hooks.templates[e])[0].split(" "), r = s[1].match(R.RegEx.valueSplit);
                                "Color" === a[0] && (a.push(a.shift()),
                                r.push(r.shift()),
                                R.Hooks.templates[e] = [a.join(" "), r.join(" ")])
                            }
                        for (e in R.Hooks.templates)
                            for (var t in a = (s = R.Hooks.templates[e])[0].split(" ")) {
                                var o = e + a[t]
                                  , n = t;
                                R.Hooks.registered[o] = [e, n]
                            }
                    },
                    getRoot: function(e) {
                        var t = R.Hooks.registered[e];
                        return t ? t[0] : e
                    },
                    cleanRootPropertyValue: function(e, t) {
                        return R.RegEx.valueUnwrap.test(t) && (t = t.match(R.RegEx.valueUnwrap)[1]),
                        t = R.Values.isCSSNullValue(t) ? R.Hooks.templates[e][1] : t
                    },
                    extractValue: function(e, t) {
                        var i = R.Hooks.registered[e];
                        if (i) {
                            e = i[0],
                            i = i[1];
                            return (t = R.Hooks.cleanRootPropertyValue(e, t)).toString().match(R.RegEx.valueSplit)[i]
                        }
                        return t
                    },
                    injectValue: function(e, t, i) {
                        var s = R.Hooks.registered[e];
                        if (s) {
                            var e = s[0]
                              , s = s[1];
                            return (e = (i = R.Hooks.cleanRootPropertyValue(e, i)).toString().match(R.RegEx.valueSplit))[s] = t,
                            e.join(" ")
                        }
                        return i
                    }
                },
                Normalizations: {
                    registered: {
                        clip: function(e, t, i) {
                            switch (e) {
                            case "name":
                                return "clip";
                            case "extract":
                                var s = R.RegEx.wrappedValueAlreadyExtracted.test(i) ? i : (s = i.toString().match(R.RegEx.valueUnwrap)) ? s[1].replace(/,(\s+)?/g, " ") : i;
                                return s;
                            case "inject":
                                return "rect(" + i + ")"
                            }
                        },
                        blur: function(e, t, i) {
                            switch (e) {
                            case "name":
                                return I.State.isFirefox ? "filter" : "-webkit-filter";
                            case "extract":
                                var s, a = parseFloat(i);
                                return a = !a && 0 !== a ? (s = i.toString().match(/blur\(([0-9]+[A-z]+)\)/i)) ? s[1] : 0 : a;
                            case "inject":
                                return parseFloat(i) ? "blur(" + i + ")" : "none"
                            }
                        },
                        opacity: function(e, t, i) {
                            if (c <= 8)
                                switch (e) {
                                case "name":
                                    return "filter";
                                case "extract":
                                    var s = i.toString().match(/alpha\(opacity=(.*)\)/i);
                                    return s ? s[1] / 100 : 1;
                                case "inject":
                                    return (t.style.zoom = 1) <= parseFloat(i) ? "" : "alpha(opacity=" + parseInt(100 * parseFloat(i), 10) + ")"
                                }
                            else
                                switch (e) {
                                case "name":
                                    return "opacity";
                                case "extract":
                                case "inject":
                                    return i
                                }
                        }
                    },
                    register: function() {
                        c <= 9 || I.State.isGingerbread || (R.Lists.transformsBase = R.Lists.transformsBase.concat(R.Lists.transforms3D));
                        for (var e = 0; e < R.Lists.transformsBase.length; e++)
                            !function() {
                                var a = R.Lists.transformsBase[e];
                                R.Normalizations.registered[a] = function(e, t, i) {
                                    switch (e) {
                                    case "name":
                                        return "transform";
                                    case "extract":
                                        return H(t) === j || H(t).transformCache[a] === j ? /^scale/i.test(a) ? 1 : 0 : H(t).transformCache[a].replace(/[()]/g, "");
                                    case "inject":
                                        var s = !1;
                                        switch (a.substr(0, a.length - 1)) {
                                        case "translate":
                                            s = !/(%|px|em|rem|vw|vh|\d)$/i.test(i);
                                            break;
                                        case "scal":
                                        case "scale":
                                            I.State.isAndroid && H(t).transformCache[a] === j && i < 1 && (i = 1),
                                            s = !/(\d)$/i.test(i);
                                            break;
                                        case "skew":
                                        case "rotate":
                                            s = !/(deg|\d)$/i.test(i)
                                        }
                                        return s || (H(t).transformCache[a] = "(" + i + ")"),
                                        H(t).transformCache[a]
                                    }
                                }
                            }();
                        for (e = 0; e < R.Lists.colors.length; e++)
                            !function() {
                                var r = R.Lists.colors[e];
                                R.Normalizations.registered[r] = function(e, t, i) {
                                    switch (e) {
                                    case "name":
                                        return r;
                                    case "extract":
                                        var s, a = R.RegEx.wrappedValueAlreadyExtracted.test(i) ? i : (s = {
                                            black: "rgb(0, 0, 0)",
                                            blue: "rgb(0, 0, 255)",
                                            gray: "rgb(128, 128, 128)",
                                            green: "rgb(0, 128, 0)",
                                            red: "rgb(255, 0, 0)",
                                            white: "rgb(255, 255, 255)"
                                        },
                                        /^[A-z]+$/i.test(i) ? a = s[i] !== j ? s[i] : s.black : R.RegEx.isHex.test(i) ? a = "rgb(" + R.Values.hexToRgb(i).join(" ") + ")" : /^rgba?\(/i.test(i) || (a = s.black),
                                        (a || i).toString().match(R.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " "));
                                        return c <= 8 || 3 !== a.split(" ").length || (a += " 1"),
                                        a;
                                    case "inject":
                                        return c <= 8 ? 4 === i.split(" ").length && (i = i.split(/\s+/).slice(0, 3).join(" ")) : 3 === i.split(" ").length && (i += " 1"),
                                        (c <= 8 ? "rgb" : "rgba") + "(" + i.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")"
                                    }
                                }
                            }()
                    }
                },
                Names: {
                    camelCase: function(e) {
                        return e.replace(/-(\w)/g, function(e, t) {
                            return t.toUpperCase()
                        })
                    },
                    SVGAttribute: function(e) {
                        var t = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
                        return (c || I.State.isAndroid && !I.State.isChrome) && (t += "|transform"),
                        new RegExp("^(" + t + ")$","i").test(e)
                    },
                    prefixCheck: function(e) {
                        if (I.State.prefixMatches[e])
                            return [I.State.prefixMatches[e], !0];
                        for (var t = ["", "Webkit", "Moz", "ms", "O"], i = 0, s = t.length; i < s; i++) {
                            var a = 0 === i ? e : t[i] + e.replace(/^\w/, function(e) {
                                return e.toUpperCase()
                            });
                            if (B.isString(I.State.prefixElement.style[a]))
                                return [I.State.prefixMatches[e] = a, !0]
                        }
                        return [e, !1]
                    }
                },
                Values: {
                    hexToRgb: function(e) {
                        return e = e.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(e, t, i, s) {
                            return t + t + i + i + s + s
                        }),
                        (e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e)) ? [parseInt(e[1], 16), parseInt(e[2], 16), parseInt(e[3], 16)] : [0, 0, 0]
                    },
                    isCSSNullValue: function(e) {
                        return 0 == e || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(e)
                    },
                    getUnitType: function(e) {
                        return /^(rotate|skew)/i.test(e) ? "deg" : /(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(e) ? "" : "px"
                    },
                    getDisplayType: function(e) {
                        e = e && e.tagName.toString().toLowerCase();
                        return /^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(e) ? "inline" : /^(li)$/i.test(e) ? "list-item" : /^(tr)$/i.test(e) ? "table-row" : /^(table)$/i.test(e) ? "table" : /^(tbody)$/i.test(e) ? "table-row-group" : "block"
                    },
                    addClass: function(e, t) {
                        e.classList ? e.classList.add(t) : e.className += (e.className.length ? " " : "") + t
                    },
                    removeClass: function(e, t) {
                        e.classList ? e.classList.remove(t) : e.className = e.className.toString().replace(new RegExp("(^|\\s)" + t.split(" ").join("|") + "(\\s|$)","gi"), " ")
                    }
                },
                getPropertyValue: function(e, t, i, n) {
                    function l(e, t) {
                        function i() {
                            a && R.setPropertyValue(e, "display", "none")
                        }
                        var s = 0;
                        if (c <= 8)
                            s = D.css(e, t);
                        else {
                            var a = !1;
                            if (/^(width|height)$/.test(t) && 0 === R.getPropertyValue(e, "display") && (a = !0,
                            R.setPropertyValue(e, "display", R.Values.getDisplayType(e))),
                            !n) {
                                if ("height" === t && "border-box" !== R.getPropertyValue(e, "boxSizing").toString().toLowerCase()) {
                                    var r = e.offsetHeight - (parseFloat(R.getPropertyValue(e, "borderTopWidth")) || 0) - (parseFloat(R.getPropertyValue(e, "borderBottomWidth")) || 0) - (parseFloat(R.getPropertyValue(e, "paddingTop")) || 0) - (parseFloat(R.getPropertyValue(e, "paddingBottom")) || 0);
                                    return i(),
                                    r
                                }
                                if ("width" === t && "border-box" !== R.getPropertyValue(e, "boxSizing").toString().toLowerCase()) {
                                    var o = e.offsetWidth - (parseFloat(R.getPropertyValue(e, "borderLeftWidth")) || 0) - (parseFloat(R.getPropertyValue(e, "borderRightWidth")) || 0) - (parseFloat(R.getPropertyValue(e, "paddingLeft")) || 0) - (parseFloat(R.getPropertyValue(e, "paddingRight")) || 0);
                                    return i(),
                                    o
                                }
                            }
                            o = H(e) === j ? O.getComputedStyle(e, null) : H(e).computedStyle ? H(e).computedStyle : H(e).computedStyle = O.getComputedStyle(e, null),
                            "borderColor" === t && (t = "borderTopColor"),
                            "" !== (s = 9 === c && "filter" === t ? o.getPropertyValue(t) : o[t]) && null !== s || (s = e.style[t]),
                            i()
                        }
                        return "auto" !== s || !/^(top|right|bottom|left)$/i.test(t) || ("fixed" === (o = l(e, "position")) || "absolute" === o && /top|left/i.test(t)) && (s = D(e).position()[t] + "px"),
                        s
                    }
                    var s, a, r;
                    if (R.Hooks.registered[t] ? (a = R.Hooks.getRoot(s = t),
                    i === j && (i = R.getPropertyValue(e, R.Names.prefixCheck(a)[0])),
                    R.Normalizations.registered[a] && (i = R.Normalizations.registered[a]("extract", e, i)),
                    s = R.Hooks.extractValue(s, i)) : R.Normalizations.registered[t] && ("transform" !== (i = R.Normalizations.registered[t]("name", e)) && (r = l(e, R.Names.prefixCheck(i)[0]),
                    R.Values.isCSSNullValue(r) && R.Hooks.templates[t] && (r = R.Hooks.templates[t][1])),
                    s = R.Normalizations.registered[t]("extract", e, r)),
                    !/^[\d-]/.test(s))
                        if (H(e) && H(e).isSVG && R.Names.SVGAttribute(t))
                            if (/^(height|width)$/i.test(t))
                                try {
                                    s = e.getBBox()[t]
                                } catch (e) {
                                    s = 0
                                }
                            else
                                s = e.getAttribute(t);
                        else
                            s = l(e, R.Names.prefixCheck(t)[0]);
                    return R.Values.isCSSNullValue(s) && (s = 0),
                    2 <= I.debug && console.log("Get " + t + ": " + s),
                    s
                },
                setPropertyValue: function(e, t, i, s, a) {
                    var r, o = t;
                    if ("scroll" === t)
                        a.container ? a.container["scroll" + a.direction] = i : "Left" === a.direction ? O.scrollTo(i, a.alternateValue) : O.scrollTo(a.alternateValue, i);
                    else if (R.Normalizations.registered[t] && "transform" === R.Normalizations.registered[t]("name", e))
                        R.Normalizations.registered[t]("inject", e, i),
                        o = "transform",
                        i = H(e).transformCache[t];
                    else {
                        if (R.Hooks.registered[t] && (r = t,
                        a = R.Hooks.getRoot(t),
                        s = s || R.getPropertyValue(e, a),
                        i = R.Hooks.injectValue(r, i, s),
                        t = a),
                        R.Normalizations.registered[t] && (i = R.Normalizations.registered[t]("inject", e, i),
                        t = R.Normalizations.registered[t]("name", e)),
                        o = R.Names.prefixCheck(t)[0],
                        c <= 8)
                            try {
                                e.style[o] = i
                            } catch (e) {
                                I.debug && console.log("Browser does not support [" + i + "] for [" + o + "]")
                            }
                        else
                            H(e) && H(e).isSVG && R.Names.SVGAttribute(t) ? e.setAttribute(t, i) : e.style[o] = i;
                        2 <= I.debug && console.log("Set " + t + " (" + o + "): " + i)
                    }
                    return [o, i]
                },
                flushTransformCache: function(t) {
                    function e(e) {
                        return parseFloat(R.getPropertyValue(t, e))
                    }
                    var i, s, a, r = "";
                    (c || I.State.isAndroid && !I.State.isChrome) && H(t).isSVG ? (i = {
                        translate: [e("translateX"), e("translateY")],
                        skewX: [e("skewX")],
                        skewY: [e("skewY")],
                        scale: 1 !== e("scale") ? [e("scale"), e("scale")] : [e("scaleX"), e("scaleY")],
                        rotate: [e("rotateZ"), 0, 0]
                    },
                    D.each(H(t).transformCache, function(e) {
                        /^translate/i.test(e) ? e = "translate" : /^scale/i.test(e) ? e = "scale" : /^rotate/i.test(e) && (e = "rotate"),
                        i[e] && (r += e + "(" + i[e].join(" ") + ") ",
                        delete i[e])
                    })) : (D.each(H(t).transformCache, function(e) {
                        return s = H(t).transformCache[e],
                        "transformPerspective" === e ? (a = s,
                        !0) : void (r += (e = 9 === c && "rotateZ" === e ? "rotate" : e) + s + " ")
                    }),
                    a && (r = "perspective" + a + " " + r)),
                    R.setPropertyValue(t, "transform", r)
                }
            };
            R.Hooks.register(),
            R.Normalizations.register(),
            I.hook = function(e, s, a) {
                var r = j;
                return e = m(e),
                D.each(e, function(e, t) {
                    var i;
                    H(t) === j && I.init(t),
                    a === j ? r === j && (r = I.CSS.getPropertyValue(t, s)) : ("transform" === (i = I.CSS.setPropertyValue(t, s, a))[0] && I.CSS.flushTransformCache(t),
                    r = i)
                }),
                r
            }
            ;
            function g() {
                function e() {
                    return t ? A.promise || null : s
                }
                function i() {
                    function i() {
                        function c(e, t) {
                            var i = j
                              , s = j
                              , a = j;
                            return B.isArray(e) ? (i = e[0],
                            !B.isArray(e[1]) && /^[\d-]/.test(e[1]) || B.isFunction(e[1]) || R.RegEx.isHex.test(e[1]) ? a = e[1] : (B.isString(e[1]) && !R.RegEx.isHex.test(e[1]) || B.isArray(e[1])) && (s = t ? e[1] : F(e[1], x.duration),
                            e[2] !== j && (a = e[2]))) : i = e,
                            t || (s = s || x.easing),
                            [(i = B.isFunction(i) ? i.call($, V, P) : i) || 0, s, a = B.isFunction(a) ? a.call($, V, P) : a]
                        }
                        function e(e, t) {
                            var t = (t || "0").toString().toLowerCase().replace(/[%A-z]+$/, function(e) {
                                return i = e,
                                ""
                            })
                              , i = i || R.Values.getUnitType(e);
                            return [t, i]
                        }
                        if (x.begin && 0 === V)
                            try {
                                x.begin.call(S, S)
                            } catch (e) {
                                setTimeout(function() {
                                    throw e
                                }, 1)
                            }
                        if ("scroll" === E) {
                            var t, i, s, a = /^x$/i.test(x.axis) ? "Left" : "Top", r = parseFloat(x.offset) || 0;
                            x.container ? B.isWrapped(x.container) || B.isNode(x.container) ? (x.container = x.container[0] || x.container,
                            s = (t = x.container["scroll" + a]) + D($).position()[a.toLowerCase()] + r) : x.container = null : (t = I.State.scrollAnchor[I.State["scrollProperty" + a]],
                            i = I.State.scrollAnchor[I.State["scrollProperty" + ("Left" === a ? "Top" : "Left")]],
                            s = D($).offset()[a.toLowerCase()] + r),
                            C = {
                                scroll: {
                                    rootPropertyValue: !1,
                                    startValue: t,
                                    currentValue: t,
                                    endValue: s,
                                    unitType: "",
                                    easing: x.easing,
                                    scrollData: {
                                        container: x.container,
                                        direction: a,
                                        alternateValue: i
                                    }
                                },
                                element: $
                            },
                            I.debug && console.log("tweensContainer (scroll): ", C.scroll, $)
                        } else if ("reverse" === E) {
                            if (!H($).tweensContainer)
                                return void D.dequeue($, x.queue);
                            var o, n;
                            for (o in "none" === H($).opts.display && (H($).opts.display = "auto"),
                            "hidden" === H($).opts.visibility && (H($).opts.visibility = "visible"),
                            H($).opts.loop = !1,
                            H($).opts.begin = null,
                            H($).opts.complete = null,
                            T.easing || delete x.easing,
                            T.duration || delete x.duration,
                            x = D.extend({}, H($).opts, x),
                            l = D.extend(!0, {}, H($).tweensContainer))
                                "element" !== o && (n = l[o].startValue,
                                l[o].startValue = l[o].currentValue = l[o].endValue,
                                l[o].endValue = n,
                                B.isEmptyObject(T) || (l[o].easing = x.easing),
                                I.debug && console.log("reverse tweensContainer (" + o + "): " + JSON.stringify(l[o]), $));
                            C = l
                        } else if ("start" === E) {
                            var l;
                            for (h in H($).tweensContainer && !0 === H($).isAnimating && (l = H($).tweensContainer),
                            D.each(k, function(e, t) {
                                if (RegExp("^" + R.Lists.colors.join("$|^") + "$").test(e)) {
                                    var i = c(t, !0)
                                      , t = i[0]
                                      , s = i[1]
                                      , i = i[2];
                                    if (R.RegEx.isHex.test(t)) {
                                        for (var a = ["Red", "Green", "Blue"], r = R.Values.hexToRgb(t), o = i ? R.Values.hexToRgb(i) : j, n = 0; n < a.length; n++) {
                                            var l = [r[n]];
                                            s && l.push(s),
                                            o !== j && l.push(o[n]),
                                            k[e + a[n]] = l
                                        }
                                        delete k[e]
                                    }
                                }
                            }),
                            k) {
                                var u = c(k[h])
                                  , d = u[0]
                                  , p = u[1]
                                  , f = u[2]
                                  , h = R.Names.camelCase(h)
                                  , m = R.Hooks.getRoot(h)
                                  , g = !1;
                                if (H($).isSVG || "tween" === m || !1 !== R.Names.prefixCheck(m)[1] || R.Normalizations.registered[m] !== j) {
                                    (x.display !== j && null !== x.display && "none" !== x.display || x.visibility !== j && "hidden" !== x.visibility) && /opacity|filter/.test(h) && !f && 0 !== d && (f = 0),
                                    x._cacheValues && l && l[h] ? (f === j && (f = l[h].endValue + l[h].unitType),
                                    g = H($).rootPropertyValueCache[m]) : R.Hooks.registered[h] ? f === j ? (g = R.getPropertyValue($, m),
                                    f = R.getPropertyValue($, h, g)) : g = R.Hooks.templates[m][1] : f === j && (f = R.getPropertyValue($, h));
                                    var v = !1
                                      , u = e(h, f)
                                      , f = u[0]
                                      , b = u[1]
                                      , d = (u = e(h, d))[0].replace(/^([+-\/*])=/, function(e, t) {
                                        return v = t,
                                        ""
                                    })
                                      , _ = u[1];
                                    if (f = parseFloat(f) || 0,
                                    d = parseFloat(d) || 0,
                                    "%" === _ && (/^(fontSize|lineHeight)$/.test(h) ? (d /= 100,
                                    _ = "em") : /^scale/.test(h) ? (d /= 100,
                                    _ = "") : /(Red|Green|Blue)$/i.test(h) && (d = d / 100 * 255,
                                    _ = "")),
                                    /[\/*]/.test(v))
                                        _ = b;
                                    else if (b !== _ && 0 !== f)
                                        if (0 === d)
                                            _ = b;
                                        else {
                                            y = y || function() {
                                                var e = {
                                                    myParent: $.parentNode || q.body,
                                                    position: R.getPropertyValue($, "position"),
                                                    fontSize: R.getPropertyValue($, "fontSize")
                                                }
                                                  , t = e.position === z.lastPosition && e.myParent === z.lastParent
                                                  , i = e.fontSize === z.lastFontSize;
                                                z.lastParent = e.myParent,
                                                z.lastPosition = e.position,
                                                z.lastFontSize = e.fontSize;
                                                var s, a = {};
                                                return i && t ? (a.emToPx = z.lastEmToPx,
                                                a.percentToPxWidth = z.lastPercentToPxWidth,
                                                a.percentToPxHeight = z.lastPercentToPxHeight) : (s = H($).isSVG ? q.createElementNS("http://www.w3.org/2000/svg", "rect") : q.createElement("div"),
                                                I.init(s),
                                                e.myParent.appendChild(s),
                                                D.each(["overflow", "overflowX", "overflowY"], function(e, t) {
                                                    I.CSS.setPropertyValue(s, t, "hidden")
                                                }),
                                                I.CSS.setPropertyValue(s, "position", e.position),
                                                I.CSS.setPropertyValue(s, "fontSize", e.fontSize),
                                                I.CSS.setPropertyValue(s, "boxSizing", "content-box"),
                                                D.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function(e, t) {
                                                    I.CSS.setPropertyValue(s, t, "100%")
                                                }),
                                                I.CSS.setPropertyValue(s, "paddingLeft", "100em"),
                                                a.percentToPxWidth = z.lastPercentToPxWidth = (parseFloat(R.getPropertyValue(s, "width", null, !0)) || 1) / 100,
                                                a.percentToPxHeight = z.lastPercentToPxHeight = (parseFloat(R.getPropertyValue(s, "height", null, !0)) || 1) / 100,
                                                a.emToPx = z.lastEmToPx = (parseFloat(R.getPropertyValue(s, "paddingLeft")) || 1) / 100,
                                                e.myParent.removeChild(s)),
                                                null === z.remToPx && (z.remToPx = parseFloat(R.getPropertyValue(q.body, "fontSize")) || 16),
                                                null === z.vwToPx && (z.vwToPx = parseFloat(O.innerWidth) / 100,
                                                z.vhToPx = parseFloat(O.innerHeight) / 100),
                                                a.remToPx = z.remToPx,
                                                a.vwToPx = z.vwToPx,
                                                a.vhToPx = z.vhToPx,
                                                1 <= I.debug && console.log("Unit ratios: " + JSON.stringify(a), $),
                                                a
                                            }();
                                            var w = /margin|padding|left|right|width|text|word|letter/i.test(h) || /X$/.test(h) || "x" === h ? "x" : "y";
                                            switch (b) {
                                            case "%":
                                                f *= "x" == w ? y.percentToPxWidth : y.percentToPxHeight;
                                                break;
                                            case "px":
                                                break;
                                            default:
                                                f *= y[b + "ToPx"]
                                            }
                                            switch (_) {
                                            case "%":
                                                f *= 1 / ("x" == w ? y.percentToPxWidth : y.percentToPxHeight);
                                                break;
                                            case "px":
                                                break;
                                            default:
                                                f *= 1 / y[_ + "ToPx"]
                                            }
                                        }
                                    switch (v) {
                                    case "+":
                                        d = f + d;
                                        break;
                                    case "-":
                                        d = f - d;
                                        break;
                                    case "*":
                                        d *= f;
                                        break;
                                    case "/":
                                        d = f / d
                                    }
                                    C[h] = {
                                        rootPropertyValue: g,
                                        startValue: f,
                                        currentValue: f,
                                        endValue: d,
                                        unitType: _,
                                        easing: p
                                    },
                                    I.debug && console.log("tweensContainer (" + h + "): " + JSON.stringify(C[h]), $)
                                } else
                                    I.debug && console.log("Skipping [" + m + "] due to a lack of browser support.")
                            }
                            C.element = $
                        }
                        C.element && (R.Values.addClass($, "velocity-animating"),
                        N.push(C),
                        "" === x.queue && (H($).tweensContainer = C,
                        H($).opts = x),
                        H($).isAnimating = !0,
                        V === P - 1 ? (I.State.calls.push([N, S, x, null, A.resolver]),
                        !1 === I.State.isTicking && (I.State.isTicking = !0,
                        L())) : V++)
                    }
                    var y, $ = this, x = D.extend({}, I.defaults, T), C = {};
                    switch (H($) === j && I.init($),
                    parseFloat(x.delay) && !1 !== x.queue && D.queue($, x.queue, function(e) {
                        I.velocityQueueEntryFlag = !0,
                        H($).delayTimer = {
                            setTimeout: setTimeout(e, parseFloat(x.delay)),
                            next: e
                        }
                    }),
                    x.duration.toString().toLowerCase()) {
                    case "fast":
                        x.duration = 200;
                        break;
                    case "normal":
                        x.duration = 400;
                        break;
                    case "slow":
                        x.duration = 600;
                        break;
                    default:
                        x.duration = parseFloat(x.duration) || 1
                    }
                    !1 !== I.mock && (!0 === I.mock ? x.duration = x.delay = 1 : (x.duration *= parseFloat(I.mock) || 1,
                    x.delay *= parseFloat(I.mock) || 1)),
                    x.easing = F(x.easing, x.duration),
                    x.begin && !B.isFunction(x.begin) && (x.begin = null),
                    x.progress && !B.isFunction(x.progress) && (x.progress = null),
                    x.complete && !B.isFunction(x.complete) && (x.complete = null),
                    x.display !== j && null !== x.display && (x.display = x.display.toString().toLowerCase(),
                    "auto" === x.display && (x.display = I.CSS.Values.getDisplayType($))),
                    x.visibility !== j && null !== x.visibility && (x.visibility = x.visibility.toString().toLowerCase()),
                    x.mobileHA = x.mobileHA && I.State.isMobile && !I.State.isGingerbread,
                    !1 === x.queue ? x.delay ? setTimeout(i, x.delay) : i() : D.queue($, x.queue, function(e, t) {
                        return !0 === t ? (A.promise && A.resolver(S),
                        !0) : (I.velocityQueueEntryFlag = !0,
                        void i())
                    }),
                    "" !== x.queue && "fx" !== x.queue || "inprogress" === D.queue($)[0] || D.dequeue($)
                }
                var t, s, a, S, k, r = arguments[0] && (arguments[0].p || D.isPlainObject(arguments[0].properties) && !arguments[0].properties.names || B.isString(arguments[0].properties));
                if (B.isWrapped(this) ? (t = !1,
                a = 0,
                s = S = this) : (t = !0,
                a = 1,
                S = r ? arguments[0].elements || arguments[0].e : arguments[0]),
                S = m(S)) {
                    T = r ? (k = arguments[0].properties || arguments[0].p,
                    arguments[0].options || arguments[0].o) : (k = arguments[a],
                    arguments[a + 1]);
                    var P = S.length
                      , V = 0;
                    if (!/^(stop|finish|finishAll)$/i.test(k) && !D.isPlainObject(T))
                        for (var T = {}, o = a + 1; o < arguments.length; o++)
                            B.isArray(arguments[o]) || !/^(fast|normal|slow)$/i.test(arguments[o]) && !/^\d/.test(arguments[o]) ? B.isString(arguments[o]) || B.isArray(arguments[o]) ? T.easing = arguments[o] : B.isFunction(arguments[o]) && (T.complete = arguments[o]) : T.duration = arguments[o];
                    var E, A = {
                        promise: null,
                        resolver: null,
                        rejecter: null
                    };
                    switch (t && I.Promise && (A.promise = new I.Promise(function(e, t) {
                        A.resolver = e,
                        A.rejecter = t
                    }
                    )),
                    k) {
                    case "scroll":
                        E = "scroll";
                        break;
                    case "reverse":
                        E = "reverse";
                        break;
                    case "finish":
                    case "finishAll":
                    case "stop":
                        D.each(S, function(e, t) {
                            H(t) && H(t).delayTimer && (clearTimeout(H(t).delayTimer.setTimeout),
                            H(t).delayTimer.next && H(t).delayTimer.next(),
                            delete H(t).delayTimer),
                            "finishAll" !== k || !0 !== T && !B.isString(T) || (D.each(D.queue(t, B.isString(T) ? T : ""), function(e, t) {
                                B.isFunction(t) && t()
                            }),
                            D.queue(t, B.isString(T) ? T : "", []))
                        });
                        var n = [];
                        return D.each(I.State.calls, function(a, r) {
                            r && D.each(r[1], function(e, i) {
                                var s = T === j ? "" : T;
                                return !0 !== s && r[2].queue !== s && (T !== j || !1 !== r[2].queue) || void D.each(S, function(e, t) {
                                    t === i && (!0 !== T && !B.isString(T) || (D.each(D.queue(t, B.isString(T) ? T : ""), function(e, t) {
                                        B.isFunction(t) && t(null, !0)
                                    }),
                                    D.queue(t, B.isString(T) ? T : "", [])),
                                    "stop" === k ? (H(t) && H(t).tweensContainer && !1 !== s && D.each(H(t).tweensContainer, function(e, t) {
                                        t.endValue = t.currentValue
                                    }),
                                    n.push(a)) : "finish" !== k && "finishAll" !== k || (r[2].duration = 1))
                                })
                            })
                        }),
                        "stop" === k && (D.each(n, function(e, t) {
                            $(t, !0)
                        }),
                        A.promise && A.resolver(S)),
                        e();
                    default:
                        if (!D.isPlainObject(k) || B.isEmptyObject(k)) {
                            if (B.isString(k) && I.Redirects[k]) {
                                var l = (p = D.extend({}, T)).duration
                                  , c = p.delay || 0;
                                return !0 === p.backwards && (S = D.extend(!0, [], S).reverse()),
                                D.each(S, function(e, t) {
                                    parseFloat(p.stagger) ? p.delay = c + parseFloat(p.stagger) * e : B.isFunction(p.stagger) && (p.delay = c + p.stagger.call(t, e, P)),
                                    p.drag && (p.duration = parseFloat(l) || (/^(callout|transition)/.test(k) ? 1e3 : 400),
                                    p.duration = Math.max(p.duration * (p.backwards ? 1 - e / P : (e + 1) / P), .75 * p.duration, 200)),
                                    I.Redirects[k].call(t, t, p || {}, e, P, S, A.promise ? A : j)
                                }),
                                e()
                            }
                            var u = "Velocity: First argument (" + k + ") was not a property map, a known action, or a registered redirect. Aborting.";
                            return A.promise ? A.rejecter(new Error(u)) : console.log(u),
                            e()
                        }
                        E = "start"
                    }
                    var d, p, z = {
                        lastParent: null,
                        lastPosition: null,
                        lastFontSize: null,
                        lastPercentToPxWidth: null,
                        lastPercentToPxHeight: null,
                        lastEmToPx: null,
                        remToPx: null,
                        vwToPx: null,
                        vhToPx: null
                    }, N = [];
                    if (D.each(S, function(e, t) {
                        B.isNode(t) && i.call(t)
                    }),
                    (p = D.extend({}, I.defaults, T)).loop = parseInt(p.loop),
                    d = 2 * p.loop - 1,
                    p.loop)
                        for (var f = 0; f < d; f++) {
                            var h = {
                                delay: p.delay,
                                progress: p.progress
                            };
                            f === d - 1 && (h.display = p.display,
                            h.visibility = p.visibility,
                            h.complete = p.complete),
                            g(S, "reverse", h)
                        }
                    return e()
                }
            }
            (I = D.extend(g, I)).animate = g;
            var x = O.requestAnimationFrame || t;
            return I.State.isMobile || q.hidden === j || q.addEventListener("visibilitychange", function() {
                q.hidden ? (x = function(e) {
                    return setTimeout(function() {
                        e(!0)
                    }, 16)
                }
                ,
                L()) : x = O.requestAnimationFrame || t
            }),
            e.Velocity = I,
            e !== O && (e.fn.velocity = g,
            e.fn.velocity.defaults = I.defaults),
            D.each(["Down", "Up"], function(e, u) {
                I.Redirects["slide" + u] = function(i, e, t, s, a, r) {
                    var e = D.extend({}, e)
                      , o = e.begin
                      , n = e.complete
                      , l = {
                        height: "",
                        marginTop: "",
                        marginBottom: "",
                        paddingTop: "",
                        paddingBottom: ""
                    }
                      , c = {};
                    e.display === j && (e.display = "Down" === u ? "inline" === I.CSS.Values.getDisplayType(i) ? "inline-block" : "block" : "none"),
                    e.begin = function() {
                        for (var e in o && o.call(a, a),
                        l) {
                            c[e] = i.style[e];
                            var t = I.CSS.getPropertyValue(i, e);
                            l[e] = "Down" === u ? [t, 0] : [0, t]
                        }
                        c.overflow = i.style.overflow,
                        i.style.overflow = "hidden"
                    }
                    ,
                    e.complete = function() {
                        for (var e in c)
                            i.style[e] = c[e];
                        n && n.call(a, a),
                        r && r.resolver(a)
                    }
                    ,
                    I(i, l, e)
                }
            }),
            D.each(["In", "Out"], function(e, l) {
                I.Redirects["fade" + l] = function(e, t, i, s, a, r) {
                    var o = D.extend({}, t)
                      , t = {
                        opacity: "In" === l ? 1 : 0
                    }
                      , n = o.complete;
                    o.complete = i !== s - 1 ? o.begin = null : function() {
                        n && n.call(a, a),
                        r && r.resolver(a)
                    }
                    ,
                    o.display === j && (o.display = "In" === l ? "auto" : "none"),
                    I(this, t, o)
                }
            }),
            I
        }
        function v(e) {
            return -e.tension * e.x - e.friction * e.v
        }
        function b(e, t, i) {
            e = {
                x: e.x + i.dx * t,
                v: e.v + i.dv * t,
                tension: e.tension,
                friction: e.friction
            };
            return {
                dx: e.v,
                dv: v(e)
            }
        }
        jQuery.fn.velocity = jQuery.fn.animate
    }(window.jQuery || window.Zepto || window, window, document)
});
